import React, { Component, Fragment } from "react";
import ConfirmButton from "./../../../components/buttons/ConfirmButton";
import Modal from "./../../../components/modalComponent/ModalComponent";
import ImportFormContainer from "../../ImportFormContainer";
class ImportMetier extends Component {
	state = { showModal: false };
	render() {
		return (
			<Fragment>
				<Modal
					title="Import référentiel métier"
					showModal={this.state.showModal}
					closeModal={() => this.setState({ showModal: false })}
					{...this.props}
				>
					<div>
						<ImportFormContainer
							{...this.props}
							title="référentiel metier"
							importUri={"referentiel"}
						/>
					</div>
				</Modal>
				<div className="p-mrg-right">
					<ConfirmButton
						label="Importer un référentiel métier"
						large={true}
						onClick={() => this.setState({ showModal: true })}
					/>
				</div>
			</Fragment>
		);
	}
}
export default ImportMetier;



// WEBPACK FOOTER //
// src/containers/admin/metier/ImportMetier.js